import { sanitize } from 'dompurify';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Modal } from '../stories/Modal';
import { base64DecodeUnicode } from '../utils';

interface LiveClassFeedbackModalProps {
  show: boolean;
  onClose: () => void;
  htmlText: string | null;
}

export const LiveClassFeedbackModal: FC<LiveClassFeedbackModalProps> = ({
  show,
  onClose,
  htmlText,
}) => {
  const __ = useTranslation().t;

  const modalProps = {
    show,
    type: 'default',
    submitButtonText: __('continue'),
    title: __('teachersReport'),
  };

  const decodedHtmlText = base64DecodeUnicode(htmlText || '');
  const formattedHtmlText = htmlText
    ? decodedHtmlText.replaceAll('<p>', '<div>').replaceAll('</p>', '</div>')
    : '';

  return (
    <StyledModal {...modalProps} onClose={onClose} onSubmit={onClose}>
      {!!htmlText && (
        <Container dangerouslySetInnerHTML={{ __html: sanitize(formattedHtmlText) }} />
      )}
    </StyledModal>
  );
};

const Container = styled.div`
  font-size: 12pt;
`;

const StyledModal = styled(Modal)`
  max-width: 565px;
`;
